import { getAccountChecklistTemplatesItem } from 'CorePackage/AccountModule/selectors/accountSelectors';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import { USER_CHECKLIST_PAGE_SIZE } from '../constants/userChecklistPageSize';

export const getCheckListsTemplateList = (state: IRootState) => state.checkLists.templatesList;
export const getCheckListsTotalCount = (state: IRootState) => state.checkLists.totalCount;
export const getCheckListsPage = (state: IRootState) => state.checkLists.page;
export const getCheckListsPageCount = (state: IRootState) => state.checkLists.pageCount;
export const getCheckListsOrder = (state: IRootState) => state.checkLists.order;
export const getCheckListsActiveTemplateId = (state: IRootState) => state.checkLists.activeTemplateId;
export const getCheckListsTemplates = (state: IRootState) =>
  getAccountChecklistTemplatesItem(state, {
    order: getCheckListsOrder(state),
    page: getCheckListsPage(state).toString(),
    size: USER_CHECKLIST_PAGE_SIZE,
  });
